import * as Tabs from "../Tabs";
import { Preview } from "./Preview";
import { FormattedMessage } from "react-intl";
import { forwardRef } from "react";
import { LexicalEditor } from "lexical";
import { Write, WriteProps } from "./Write";

const MarkdownEditor = forwardRef<LexicalEditor | null, WriteProps>(
  function (props, ref) {
    return (
      <Tabs.Root defaultValue="write" className="w-full">
        <Tabs.List>
          <Tabs.Trigger value="write">
            <FormattedMessage defaultMessage="Write" />
          </Tabs.Trigger>
          <Tabs.Trigger value="preview">
            <FormattedMessage defaultMessage="Preview" />
          </Tabs.Trigger>
        </Tabs.List>
        <Tabs.Content value="write">
          <Write {...props} ref={ref} />
        </Tabs.Content>
        <Tabs.Content value="preview">
          <Preview value={props.value} />
        </Tabs.Content>
      </Tabs.Root>
    );
  },
);

export default MarkdownEditor;
